import {Injectable} from '@angular/core';
import {OktaAuth} from '@okta/okta-auth-js';

@Injectable({providedIn: 'root'})
export class OktaAuthService {

  constructor(private oktaAuth: OktaAuth) {
  }

  public logout(): void {
    this.oktaAuth.tokenManager.clear();
    this.oktaAuth.closeSession()
      .then(() => this.oktaAuth.signOut())
      .then(() => this.oktaAuth.handleLoginRedirect());
  }
}
